var map = {
	"./epub_logo_color": 132,
	"./epub_logo_color.svg": 132,
	"./header-stripes": 133,
	"./header-stripes.png": 133,
	"./insights/carbon-footprint-review-copies-fig-1": 134,
	"./insights/carbon-footprint-review-copies-fig-1.jpg": 134,
	"./landing_hero_large": 135,
	"./landing_hero_large.jpg": 135,
	"./landing_side_bookshops": 136,
	"./landing_side_bookshops.jpg": 136,
	"./landing_side_publishers": 137,
	"./landing_side_publishers.jpg": 137,
	"./landing_side_readers": 138,
	"./landing_side_readers.jpg": 138,
	"./logos/ace": 139,
	"./logos/ace.png": 139,
	"./logos/ba": 140,
	"./logos/ba.png": 140,
	"./logos/blackwells": 141,
	"./logos/blackwells.png": 141,
	"./logos/facebook": 142,
	"./logos/facebook.svg": 142,
	"./logos/innovate_uk": 143,
	"./logos/innovate_uk.png": 143,
	"./logos/publishers-association": 144,
	"./logos/publishers-association.png": 144,
	"./logos/twitter": 145,
	"./logos/twitter.svg": 145,
	"./nav-bar-icons": 146,
	"./nav-bar-icons.svg": 146,
	"./opengraph_share_default_de": 147,
	"./opengraph_share_default_de.jpg": 147,
	"./opengraph_share_default_en": 148,
	"./opengraph_share_default_en.jpg": 148,
	"./products/discovery-retailers-details": 149,
	"./products/discovery-retailers-details.jpg": 149,
	"./products/discovery-retailers-landing": 150,
	"./products/discovery-retailers-landing-zoomed": 151,
	"./products/discovery-retailers-landing-zoomed.jpg": 151,
	"./products/discovery-retailers-landing.jpg": 150,
	"./products/retailers-customised-1-hero": 152,
	"./products/retailers-customised-1-hero.jpg": 152,
	"./products/retailers-customised-2-sample01": 153,
	"./products/retailers-customised-2-sample01.jpg": 153,
	"./products/retailers-customised-3-bookshop-info": 154,
	"./products/retailers-customised-3-bookshop-info.jpg": 154,
	"./products/retailers-customised-4-reserve": 155,
	"./products/retailers-customised-4-reserve.jpg": 155,
	"./products/retailers-customised-5-sample02": 156,
	"./products/retailers-customised-5-sample02.jpg": 156,
	"./products/retailers-customised-6-sample03": 157,
	"./products/retailers-customised-6-sample03.jpg": 157,
	"./products/retailers-customised-7-sample04": 158,
	"./products/retailers-customised-7-sample04.jpg": 158,
	"./products/retailers-customised-8-sample05": 159,
	"./products/retailers-customised-8-sample05.jpg": 159,
	"./products/retailers-customised-9-sample06": 160,
	"./products/retailers-customised-9-sample06.jpg": 160,
	"./products/retailers-ecommerce-1-hero": 161,
	"./products/retailers-ecommerce-1-hero.jpg": 161,
	"./products/retailers-ecommerce-2-sample01": 162,
	"./products/retailers-ecommerce-2-sample01.jpg": 162,
	"./products/retailers-ecommerce-3-sample02": 163,
	"./products/retailers-ecommerce-3-sample02.jpg": 163,
	"./products/retailers-ecommerce-4-sample03": 164,
	"./products/retailers-ecommerce-4-sample03.jpg": 164,
	"./products/retailers-ecommerce-5-sample04": 165,
	"./products/retailers-ecommerce-5-sample04.jpg": 165,
	"./products/retailers-ecommerce-6-portal": 166,
	"./products/retailers-ecommerce-6-portal.jpg": 166,
	"./products/retailers-ecommerce-7-waterstones-sample": 167,
	"./products/retailers-ecommerce-7-waterstones-sample.jpg": 167,
	"./products/retailers-newsletter-1-hero": 168,
	"./products/retailers-newsletter-1-hero.jpg": 168,
	"./products/retailers-newsletter-2-blackwells": 169,
	"./products/retailers-newsletter-2-blackwells.jpg": 169,
	"./products/retailers-newsletter-3-guardian": 170,
	"./products/retailers-newsletter-3-guardian.jpg": 170,
	"./products/retailers-og-1": 171,
	"./products/retailers-og-1.jpg": 171,
	"./products/retailers-og-2": 172,
	"./products/retailers-og-2.jpg": 172,
	"./products/retailers-og-3": 173,
	"./products/retailers-og-3.jpg": 173,
	"./products/retailers-og-4": 174,
	"./products/retailers-og-4.jpg": 174,
	"./products/retailers-og-5": 175,
	"./products/retailers-og-5.jpg": 175,
	"./products/retailers-og-6": 176,
	"./products/retailers-og-6.jpg": 176,
	"./products/retailers-product-2-grumpus": 177,
	"./products/retailers-product-2-grumpus.jpg": 177,
	"./products/retailers-product-3-newsletters": 178,
	"./products/retailers-product-3-newsletters.jpg": 178,
	"./products/retailers-product-4-tweets": 179,
	"./products/retailers-product-4-tweets.jpg": 179,
	"./products/retailers-product-5-product-page": 180,
	"./products/retailers-product-5-product-page.jpg": 180,
	"./products/retailers-socialmedia-1-hero": 181,
	"./products/retailers-socialmedia-1-hero.jpg": 181,
	"./products/retailers-socialmedia-2-tweets-blackwells": 182,
	"./products/retailers-socialmedia-2-tweets-blackwells.jpg": 182,
	"./products/retailers-socialmedia-3-tweets-multi-links": 183,
	"./products/retailers-socialmedia-3-tweets-multi-links.jpg": 183,
	"./products/retailers-socialmedia-4-buy-pages": 184,
	"./products/retailers-socialmedia-4-buy-pages.jpg": 184,
	"./products/retailers-socialmedia-5-smart-link": 185,
	"./products/retailers-socialmedia-5-smart-link.jpg": 185,
	"./products/retailers-socialmedia-6-excerpt-page": 186,
	"./products/retailers-socialmedia-6-excerpt-page.jpg": 186,
	"./qr/audiobook-qr-colour": 187,
	"./qr/audiobook-qr-colour.svg": 187,
	"./qr/audiobook-qr-mono": 188,
	"./qr/audiobook-qr-mono.svg": 188,
	"./qr/graphic-qr-colour": 189,
	"./qr/graphic-qr-colour.svg": 189,
	"./qr/graphic-qr-mono": 190,
	"./qr/graphic-qr-mono.svg": 190,
	"./qr/illustrated-qr-colour": 191,
	"./qr/illustrated-qr-colour.svg": 191,
	"./qr/illustrated-qr-mono": 192,
	"./qr/illustrated-qr-mono.svg": 192,
	"./qr/narrative-qr-colour": 81,
	"./qr/narrative-qr-colour.svg": 81,
	"./qr/narrative-qr-mono": 82,
	"./qr/narrative-qr-mono.svg": 82,
	"./readers-landing-page": 193,
	"./readers-landing-page.jpg": 193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 196;